<template>
  <div>
    <div class="modal-overlay" @click.self="closeWorkModal">
      <div class="modal-content" id="scroller">
        <div class="flex gap-2 mb-3">
          <img class="cursor-pointer" @click="openPrevModal"
            src="../../../../../views/3pl/BillingandCollection/icons/back-arrow.svg" alt="">
          <h1>How it works</h1>
        </div>

        <div id="scroller" class="">
          <div class=" pl-3 pt-3 pb-3 ">
            <b>Partner Perks Program for Independent Logistics Dispatchers <br />Why?</b>
            <p class="mt-2">We’re here to do more than just give you deliveries.<br />
              Our <b>Partner Perks Program</b> helps you earn more, save more on running your business, and get rewarded
              for your hard work. <br />
              Tiers are based on performance metrics such as the number of completed deliveries, customer ratings,
              timeliness, and package handling.</p>
            <div class="table-cover mt-2">
              <table class="responsive-table  border-collapse w-full">
                <thead class="font-normal ">
                  <tr class="">
                    <th>Tier</th>
                    <th>Name</th>
                    <th>Equivalent Deliveries</th>
                  </tr>
                </thead>
                <tbody v-for="(tabdet, index) in tableDetails" :key="index">
                  <tr class="">
                    <td>{{ tabdet.tier }}</td>
                    <td>{{ tabdet.name }}</td>
                    <td>{{ tabdet.equivalentDeliveries }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div class="px-2 py-2">
            <hr>
          </div>

          <div class="">
            <div class=" pl-3 pt-3 pb-3 ">
              <b>1. Complete enough transactions to move to a higher tie</b>
              <p>Complete enough transactions during one of the listed qualifying periods.<br />
                <b class="mr-2">.</b>January 1 - March 31<br />
                <b class="mr-2">.</b> April 1 - June 30<br />
                <b class="mr-2">.</b> July 1 - September 30<br />
                <b class="mr-2">.</b> October 1 - December 31
              </p>
              <b>2. Reward validity period.</b>
              <p>When you reach a higher Tier, you unlock the rewards immediately you reach them,
                valid through to the end of the next period. If however,
                you fail to complete enough transactions to keep you at your current tier or higher,
                you will be downgraded to a lower tier at the start of the next period.</p>
            </div>
          </div>

          <div class="px-2 py-2">
            <hr>
          </div>

          <div class="flex justify-end">
            <div class="flex py-4">
              <img width="20"  src="../../../../../views/3pl/BillingandCollection/icons/silver.svg" alt="">
              <h3>Silver Tier</h3>
            </div>
            <div class="flex py-4">
              <img width="20"  src="../../../../../views/3pl/BillingandCollection/icons/gold.svg" alt="">
              <h3>Gold Tier</h3>
            </div>
            <div class="flex py-4">
              <img width="20"  src="../../../../../views/3pl/BillingandCollection/icons/diamond.svg" alt="">
              <h3>Diamond Tier</h3>
            </div>
          </div>

          <div class="flex py-2 gap-2">
            <img width="20"  src="../../../../../views/3pl/BillingandCollection/icons/green-check.svg" alt="">
            <p>Requirements</p>
          </div>

          <div class="flex gap-2 mt-4">
            <div class="py-2 pl-2">
              <b>Equivalent Deliveries<br />
                Min. customer rating</b>
            </div>
            <div class="justify-center py-2">
              <p>1-49<br />
              4.5</p>
            </div>
            <div class=" justify-center py-2">
              <p>50-199<br />
              4.5</p>
            </div>
             <div class=" justify-center py-2">
              <p>200+<br />
              200+</p>
            </div>
          </div>

          <div class="flex py-2 gap-2 mt-2">
            <img width="20"  src="../../../../../views/3pl/BillingandCollection/icons/green-gift-box.svg" alt="">
            <p>Rewards</p>
          </div>

          <div class="flex gap-2 mt-4">
            <div class="py-2 pl-2">
              <b>Equivalent Deliveries<br />
                Min. customer rating</b>
            </div>
            <div class="justify-center py-2">
              <p>1-49<br />
              4.5</p>
            </div>
            <div class=" justify-center py-2">
              <p>50-199<br />
              4.5</p>
            </div>
             <div class=" justify-center py-2">
              <p>200+<br />
              200+</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {

      tableDetails: [
        {
          tier: 1,
          name: 'Silver',
          equivalentDeliveries: "1-49"
        },
        {
          tier: 2,
          name: 'Gold',
          equivalentDeliveries: "50-199"

        },
        {
          tier: 3,
          name: 'Diamond',
          equivalentDeliveries: "200+"
        },
      ]
    };
  },

  methods: {
    closeWorkModal() {
      this.$emit('close-work-modal', close)
    },
    openPrevModal() {
      this.$emit('open-prev-modal')
    },
  },

}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 12px;
  max-width: 850px;
  width: 90%;
}

#scroller {
  max-height: 600px;
  overflow-y: auto;
}

.modal-content>:nth-child(1) h1 {
  color: #10233E;
  font-weight: 600;
  font-size: 24px;
}

.modal-content>:nth-child(2)>:nth-child(1) {
  background: #F2F7FC;
  border-radius: 8px;
}

b {
  color: #000000;
  font-size: 14px;
}

p {
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5rem;
}


.table-cover>table>thead>tr>th {
  color: #000000;
  font-weight: 600;
  font-size: 14px;
}

.table-cover>table>tbody>tr>td {
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  padding: 0;
  margin: 0;
  padding: 0.3%;
}

.modal-content>:nth-child(2)>:nth-child(2) hr {
  border: 1px dashed #DAE8F6;
}

.modal-content>:nth-child(2)>:nth-child(3) {
  background: #F2F7FC;
  border-radius: 8px;
}

.modal-content>:nth-child(2)>:nth-child(4) hr {
  border: 1px dashed #DAE8F6;
}

.modal-content>:nth-child(2)>:nth-child(5) {
  /* border: 1px solid red; */
  padding: 2% 2% 0 0;
  gap: 2%;
}
.modal-content>:nth-child(2)>:nth-child(5)>div {
  border-radius: 12px;
  border: 1px solid #A5ADB7;
  /* padding: 2%; */
  justify-content: center;
  align-items: center;
  gap: 2%;
  flex-basis: 20%;
  
}
.modal-content>:nth-child(2)>:nth-child(5)>div h3 {
  color: #14171F;
  font-weight: 700;
  font-size: 16px;
}

.modal-content>:nth-child(2)>:nth-child(6) p {
  color: #09B78A;
  font-weight: 700;
  font-size: 16px;
}

.modal-content>:nth-child(2)>:nth-child(7)>:nth-child(1) {
  width: 35%;
}
.modal-content>:nth-child(2)>:nth-child(7)>div {
  border: 1px solid #A5ADB7;
  border-radius: 12px;
   width: 20%;
   display: flex;
}
.modal-content>:nth-child(2)>:nth-child(7)>div>b {
  color: #14171F;
  font-weight: 700;
  font-size: 16px;
}
.modal-content>:nth-child(2)>:nth-child(7)>div>p {
  color: #14171F;
  font-weight: 400;
  font-size: 16px;
}
.modal-content>:nth-child(2)>:nth-child(8) p {
  color: #09B78A;
  font-weight: 700;
  font-size: 16px;
}
.modal-content>:nth-child(2)>:nth-child(9)>:nth-child(1) {
  width: 35%;
}
.modal-content>:nth-child(2)>:nth-child(9)>div {
  border: 1px solid #A5ADB7;
  border-radius: 12px;
   width: 20%;
   display: flex;
}
.modal-content>:nth-child(2)>:nth-child(9)>div>b {
  color: #14171F;
  font-weight: 700;
  font-size: 16px;
}
.modal-content>:nth-child(2)>:nth-child(9)>div>p {
  color: #14171F;
  font-weight: 400;
  font-size: 16px;
}
</style>